import { FC, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { OrderType } from "../enums";
import { BiDollar } from "react-icons/bi";
import ConfirmModal from "./_modals/ConfirmModal";

type Props = {
  defaultValue?: string;
  orderTypeId: number;
  handleChange: (percentage: string) => void;
};

const tipOptions = [
  // {id: '0', label: 'No Tip'},
  { id: "10%", label: "10%" },
  { id: "15%", label: "15%" },
  { id: "20%", label: "20%" },
  { id: "25%", label: "25%" },
];

export const AddTip: FC<Props> = ({
  defaultValue = "10%",
  orderTypeId,
  handleChange,
}) => {
  const [showInfo, setShowInfo] = useState(false);

  const [_, setTip] = useState<string>("");
  const [activeTab, setActiveTab] = useState<string>(defaultValue); // Set the default active tab

  const onTipSelect = (value: string) => {
    const isSame = value === activeTab;
    const newValue = isSame ? "0" : value;

    setActiveTab(isSame ? "" : value);
    handleChange(newValue);
  };

  const handleCustomTip = (e: React.FocusEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (orderTypeId == OrderType.DELIVERY && value && parseFloat(value) < 5) {
      setShowInfo(true);
    }

    if (value) {
      handleChange(value);
    }
  };

  const handleTipChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value.replace(/[^0-9.]/g, "");

    const parts = value.split(".");
    if (parts.length > 2) {
      value = `${parts[0]}.${parts.slice(1).join("")}`;
    }

    if (parts[1]?.length > 2) {
      value = `${parts[0]}.${parts[1].slice(0, 2)}`;
    }

    setTip(value);
  };

  return (
    <>
      <div className="choose_payment_addtip pb-0 mb-3">
        <h2 className="pb-0">Add a Tip</h2>
        {orderTypeId == OrderType.DELIVERY && (
          <p className="text-muted">
            They make delivery possible - no matter what time it is
          </p>
        )}

        <div className="mt-2 p-3 rounded d-flex flex-wrap gap-2">
          <ul>
            {tipOptions.map((item: { id: string; label: string }) => (
              <li
                key={item.id}
                className={`d-flex align-items-center ${activeTab === item.id ? "active" : ""}`}
                onClick={() => onTipSelect(item.id)}
              >
                {item.label}
              </li>
            ))}
            <li
              className={`d-flex align-items-center ${activeTab === "other" ? "active" : ""}`}
              onClick={() => setActiveTab("other")}
            >
              Other
            </li>
          </ul>

          {activeTab === "other" && (
            <InputGroup className="flex-fill my-1 custom-top-input">
              <InputGroup.Text>
                <BiDollar />
              </InputGroup.Text>
              <Form.Control
                type="number"
                max={100}
                min={0}
                step={0.1}
                maxLength={3}
                placeholder="Add custom tip here"
                onChange={handleTipChange}
                onBlur={handleCustomTip}
              />
            </InputGroup>
          )}
        </div>
      </div>

      <ConfirmModal
        show={showInfo}
        title="Hi"
        content={
          <>
            <p>
              We recommend increasing your tip amount to ensure that your order
              is delivered in time and prioritized by the DoorDash dasher. Like
              always, 100% of your tip amount goes to your dasher. Thank you for
              your support.
            </p>
            <p>
              For all deliveries and restaurant independent driver: Thank you
              for your generosity. 100% of your tips go directly to your driver.
            </p>
          </>
        }
        btnText="Okay, Got It"
        handleSubmit={() => setShowInfo(false)}
        handleClose={() => setShowInfo(false)}
      />
    </>
  );
};
